import { doesWindowExist } from './dom.utils';

/**
 * The default isChromatic check assumes window is available
 * Our usage is universal so we need to add this thin abstraction
 */
export function isChromatic() {
	return doesWindowExist() && (/Chromatic/.test(window.navigator.userAgent) || /chromatic=true/.test(window.location.href));
}
